import React from 'react';
import { Collapse as MuiCollapse, CollapseProps as MuiCollapseProps } from '@material-ui/core';
import { isCypressTest } from '../../isCypressTest';

export interface CollapseProps extends Omit<MuiCollapseProps, 'children'> {
  children?: React.ReactNode;
}

const Collapse: React.FC<CollapseProps> = ({
  children,
  timeout,
  in: inProp,
  className,
  style,
  collapsedHeight,
  component,
  onEnter,
  onEntered,
  onEntering,
  onExit,
  onExited,
  onExiting,
}) => {
  return (
    <MuiCollapse
      in={inProp}
      className={className}
      style={style}
      collapsedHeight={collapsedHeight}
      component={component}
      timeout={isCypressTest ? 0 : timeout}
      onEnter={onEnter}
      onEntered={onEntered}
      onEntering={onEntering}
      onExit={onExit}
      onExited={onExited}
      onExiting={onExiting}
    >
      {children}
    </MuiCollapse>
  );
};

export default Collapse;
